// extracted by mini-css-extract-plugin
export default {"tag":"BetterTag_tag__iqh0G"};